import { DatePicker } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import { ValidationFailure } from "../../../models";
import { setDateToUTCMidnight } from "../../../utils/formatUtils";

interface DatePickerRangeProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  errors?: ValidationFailure[];
}

export const DatePickerRange = ({
  value,
  onChange,
  disabled,
  errors,
}: DatePickerRangeProps) => {
  const { t } = useTranslation();

  const handleDateChange = (e: React.ChangeEvent<any>) => {
    const date = new Date(e.target.value);

    // Set date to UTC midnight to prevent date shift due to timezone
    onChange(setDateToUTCMidnight(date));
  };

  return (
    <div style={{ width: "max-content" }}>
      <DatePicker
        label={t("common.expertCommission.activeTo")}
        name={"common.expertCommission.activeTo"}
        onChange={handleDateChange}
        disabled={disabled}
        value={value}
        minYear={new Date().getFullYear() - 4}
        maxYear={new Date().getFullYear()}
        maxDate={new Date()}
        errorText={errors?.find((e) => e.propertyName === "DateFrom")?.message}
      />
    </div>
  );
};
